// ======================================================================
// File Name       : ChatInfo
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { Button, Card, Col, Collapse, Form } from 'react-bootstrap';
import CustomLink from '../../components/button/CustomLink';

class ChatInfo extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isShow: false,
    };
    this.changeExpandIcon = this.changeExpandIcon.bind(this);
  }

  changeExpandIcon() {
    this.setState(prevState => ({
      isShow: !prevState.isShow,
    }));
  }

  render() {
    const {
      messageTitle,
      messageContent,
      attachmentFileName,
      getNewMessage,
      messageType,
      messageIdAuto,
      downloadAttachment,
      goBack,
    } = this.props;
    const item = {
      messageType,
      messageIdAuto,
    };
    return (
      <div id="message-collapsible">
        <Col sm={12} className="padding-clear">
          <Col sm={10} className="padding-left-clear">
            <CustomLink
              className="margin-right-7 url-list"
              text="受信ボックスに戻る"
              icon="bi bi-chevron-left"
              onClick={goBack}
            />
            <Card className='margin-top-15 margin-bottom-20'>
              <Card.Header
                style={{ cursor: 'pointer' }}
                onClick={this.changeExpandIcon}
              >
                <i
                  className={`bi ${this.state.isShow
                      ? 'bi-dash-square-fill'
                      : 'bi-plus-square-fill'
                    }`}
                  style={{
                    color: '#337ab7',
                    fontSize: '13px',
                    marginRight: '7px',
                  }}
                />
                メッセージスレッドの詳細
              </Card.Header>
              <Collapse in={this.state.isShow}>
                <div className="message-thread-collapse">
                  <Card.Body>
                    <Col sm={12} className="margin-top-bot-10">
                      <Col as={Form.Label} sm={4}>
                        スレッドタイトル
                      </Col>
                      <Col sm={8}>{messageTitle}</Col>
                    </Col>
                    <Col sm={12} className="margin-top-bot-10">
                      <Col as={Form.Label} sm={4}>
                        スレッド詳細
                      </Col>
                      <Col sm={8}>{messageContent}</Col>
                    </Col>
                    <Col sm={12} className="margin-top-bot-10">
                      <Col as={Form.Label} sm={4}>
                        添付ファイル
                      </Col>
                      <Col sm={8}>
                        {attachmentFileName}{' '}
                        {attachmentFileName && (
                          <item
                            role="button"
                            className="bi bi-file-earmark-fill"
                            onClick={() => {
                              downloadAttachment(item);
                            }}
                          />
                        )}
                      </Col>
                    </Col>
                  </Card.Body>
                </div>
              </Collapse>
            </Card>
          </Col>
          <Col sm={2} className="padding-right-clear text-right">
            <Button
              variant="primary"
              className="btn-96"
              onClick={getNewMessage}
            >
              更新
            </Button>
          </Col>
          <hr className="col-sm-12 padding-clear bold-hr" />
        </Col>
      </div>
    );
  }
}

export default ChatInfo;
